import { render, staticRenderFns } from "./contract-add-or-update.vue?vue&type=template&id=017844f7&scoped=true"
import script from "./contract-add-or-update.vue?vue&type=script&lang=js"
export * from "./contract-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./contract-add-or-update.vue?vue&type=style&index=0&id=017844f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017844f7",
  null
  
)

export default component.exports